export default __webpack_public_path__ + "static/media/up-arrow.e1aa28e7.svg";